module.exports = __webpack_public_path__ + "img/avatar.292d693e.png";